module.exports = __webpack_public_path__ + "static/media/nft-18.95e8da03.png";